import { AlpineData } from "@/js/interfaces/Components/alpinejs/CopyToClipboard";
import { createAlpineComponent } from "@nolikein/typed-alpinejs";
import { notifyErrorAlert, notifySuccessAlert } from "../../support/alert-and-banner";
import { translate } from "../../support/utils";

/* Generated from the "artisan make:alpine" command */
export default {
    name: 'CopyToClipboard',
    component: (
        // Component parameters...
    ) => createAlpineComponent<AlpineData>({
        // Component properties ...

        /**
         * Initialize the component
         */
        init() {
            // ...
        },

        // Component methods ...
        copy(text: string): void {
            navigator.clipboard.writeText(text).then(() => {
                // Optionally, you can add some feedback to the user here
                notifySuccessAlert(translate('Text copied to clipboard'));
            }).catch(err => {
                // Notify the user then pass the problem to the error handler
                notifyErrorAlert(translate('Failed to copy text to clipboard'));
                throw err;
            });
        },
    }),
};
